export default __webpack_public_path__ + "static/media/instagram_icon.896afbd5.png";